import { YouTubeVideoPlayer } from '@/components/ProductDetailComponents';
import Image from '@/components/UI/Image';
import EFArrowDown from '@/components/UI/svg/Icons/EFArrowDown';
import EFWatchVideoH5 from '@/components/UI/svg/Icons/EFWatchVideoH5';
import { useGlobal } from '@/utils/useGlobal';
import css from './index.module.scss';
export default function Delta2Group3() {
    const { Link, useLang, useState, useEffect } = useGlobal();
    const [swiper, setSwiper] = useState(null);
    const [actionStatus, setActionStatus] = useState({ isBeginning: true, isEnd: false });
    const { t } = useLang('delta2portablepowerstationevent');
    const [floatVideo, setFloatVideo] = useState(false);
    const [videoSrc, setVideoSrc] = useState('');

    const data = [
        {
            imgPath: '/img/delta2Activilypage/user-swiper2.jpg',
            title: 'group3-story2-text',
            link: 'https://www.youtube.com/embed/fAHXoizK3Sw',
        },
        {
            imgPath: '/img/delta2Activilypage/user-swiper3.jpg',
            title: 'group3-story3-text',
            link: 'https://www.youtube.com/embed/Xr2ZBw9jJf0',
        },
        {
            imgPath: '/img/delta2Activilypage/user-swiper4.jpg',
            title: 'group3-story4-text',
            link: 'https://www.youtube.com/embed/v8ZqCGOA1yg',
        },
        {
            imgPath: '/img/delta2Activilypage/user-swiper5.jpg',
            title: 'group3-story5-text',
            link: 'https://www.youtube.com/embed/8IfDn7Pm9mw',
        },
        {
            imgPath: '/img/delta2Activilypage/user-swiper6.jpg',
            title: 'group3-story6-text',
            link: 'https://www.youtube.com/embed/sysKtiZ38jg',
        },
        {
            imgPath: '/img/delta2Activilypage/user-swiper7.jpg',
            title: 'group3-story7-text',
            link: 'https://www.youtube.com/embed/sodKQkDXALM',
        },
        {
            imgPath: '/img/delta2Activilypage/user-swiper8.jpg',
            title: 'group3-story8-text',
            link: 'https://www.youtube.com/embed/TEg-4RUnQqQ',
        },
        {
            imgPath: '/img/delta2Activilypage/user-swiper9.jpg',
            title: 'group3-story9-text',
            link: 'https://www.youtube.com/embed/rJVjSjWLYKI',
        },
    ];

    const playerVideo = (src: string) => {
        setFloatVideo(true);
        setVideoSrc(src);
    };

    const onHandle = (direction: string) => {
        const dom = document.querySelector('.swiper-box');
        if (!dom) {
            return null;
        }
        if (direction === 'left' && dom.scrollLeft - 5 > 0) {
            const scrollLeft = dom.scrollLeft > 317 ? dom.scrollLeft - 317 : 0;
            dom.scrollTo({ left: scrollLeft, behavior: 'smooth' });
        }
        if (direction === 'right' && dom.scrollWidth - (dom.clientWidth + dom.scrollLeft) > 5) {
            const scrollRight = dom.scrollWidth - (dom.clientWidth + dom.scrollLeft) > 317 ? dom.scrollLeft + 317 : dom.clientWidth + dom.scrollLeft;
            dom.scrollTo({ left: scrollRight, behavior: 'smooth' });
        }
    };

    useEffect(() => {
        const dom = document.getElementsByClassName('swiper-box')[0];
        const onScroll = () => {
            const obj = {
                isBeginning: dom.scrollLeft < 5,
                isEnd: dom.scrollWidth - (dom.scrollLeft + dom.clientWidth) < 5,
            };
            setActionStatus(obj);
        };
        dom?.addEventListener('scroll', onScroll);

        return () => {
            dom?.removeEventListener('scroll', onScroll);
        };
    }, []);

    return (
        <div className={css.delta2_group3}>
            <h4 className="title">{t('group3-title')}</h4>

            <div className="swiper-container">
                <div className={`swiper-action slider-prev ${actionStatus.isBeginning ? 'disabled' : ''}`} onClick={() => onHandle('left')}>
                    <EFArrowDown />
                </div>
                <div className="swiper-box">
                    {data.map((item, i) => (
                        <div key={i} className="card">
                            <div className="img-wrap">
                                <Image src={item.imgPath} layout="fill" alt="" />
                                <div className="mask">
                                    <EFWatchVideoH5 width="0.64rem" height="0.64rem" className="play-svg" onClick={() => playerVideo(item.link)} />
                                </div>
                            </div>
                            <h5 className="card-title">
                                {t.rich(item.title, {
                                    line1: (text: any) => <div className="sub-title">{text}</div>,
                                })}
                            </h5>
                        </div>
                    ))}
                </div>
                <div className={`swiper-action slider-next ${actionStatus.isEnd ? 'disabled' : ''}`} onClick={() => onHandle('right')}>
                    <EFArrowDown />
                </div>
            </div>
            <YouTubeVideoPlayer floatVideo={floatVideo} setFloatVideo={setFloatVideo} videoSrc={videoSrc} />
        </div>
    );
}
